// hooks/useCommunicationsParams.js
import { useState, useEffect } from 'react';

// Fonction utilitaire pour déclencher un événement de mise à jour
const triggerCommunicationsUpdate = () => {
  window.dispatchEvent(new CustomEvent('communicationsParamsUpdated'));
};

const useCommunicationsParams = () => {
  const [communications, setCommunications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadCommunications = async () => {
    try {
      setLoading(true);
      
      const response = await fetch('/api/parametres/communications', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        credentials: 'include'
      });

      if (!response.ok) {
        throw new Error(`Erreur ${response.status}`);
      }

      const data = await response.json();
      setCommunications(data.data || []);

    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const addCommunication = async (communicationData) => {
    try {
      const response = await fetch('/api/parametres/communications', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        credentials: 'include',
        body: JSON.stringify(communicationData)
      });

      if (!response.ok) {
        throw new Error(`Erreur ${response.status}`);
      }

      await loadCommunications();
      triggerCommunicationsUpdate();
      return { success: true };
      
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  const updateCommunication = async (id, communicationData) => {
    try {
      const response = await fetch(`/api/parametres/communications/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        credentials: 'include',
        body: JSON.stringify(communicationData)
      });

      if (!response.ok) {
        throw new Error(`Erreur ${response.status}`);
      }

      await loadCommunications();
      triggerCommunicationsUpdate();
      return { success: true };
      
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  const deleteCommunication = async (id) => {
    try {
      const response = await fetch(`/api/parametres/communications/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        credentials: 'include'
      });

      if (!response.ok) {
        throw new Error(`Erreur ${response.status}`);
      }

      await loadCommunications();
      triggerCommunicationsUpdate();
      return { success: true };
      
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  // Écouter les événements de mise à jour + chargement initial
  useEffect(() => {
    loadCommunications();
    
    // Écouter les mises à jour depuis d'autres composants
    const handleUpdate = () => {
      console.log('🔄 [useCommunicationsParams] Mise à jour temps réel détectée');
      loadCommunications();
    };
    
    window.addEventListener('communicationsParamsUpdated', handleUpdate);
    
    return () => {
      window.removeEventListener('communicationsParamsUpdated', handleUpdate);
    };
  }, []);

  return {
    communications,
    addCommunication,
    updateCommunication,
    deleteCommunication,
    loadCommunications,
    loading,
    error
  };
};

export default useCommunicationsParams;